import meiyuTypes from './types/meiyu'
import meiyuService from '@/api/meiyu'

const state = {}

const actions = {
  /**
   * 获取超讯限水位的测站点
   */
  [meiyuTypes.GET_TOWN_RAIN] ({ commit }, { sid = '', mainStation = false, type = '', aDDVCD = '', townOrderField = '', stationOrderField = '' }) {
    return new Promise((resolve, reject) => {
      meiyuService.getTownRain({ sid, mainStation, type, aDDVCD, townOrderField, stationOrderField }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 水库超汛限
   */
  [meiyuTypes.GET_RES_OVERFLOW] ({ commit }, { stationType = '', sID = '', mainStation = false }) {
    return new Promise((resolve, reject) => {
      meiyuService.getResOverflow({ stationType, sID, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 雨量超警
   */
  [meiyuTypes.GET_WATER_OVERFLOW] ({ commit }, { sID = '', mainStation = false }) {
    return new Promise((resolve, reject) => {
      meiyuService.getWaterOverflow({ sID, mainStation }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 预警村落
   */
  [meiyuTypes.GET_WARN_VILLAGE] ({ commit }, { pageIndex = '', pageSize = '' }) {
    return new Promise((resolve, reject) => {
      meiyuService.getWarnVillage({ pageIndex, pageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 梅雨季节降雨信息
   */
  [meiyuTypes.GET_RAINLY_SEASON_RAINFALL] ({ commit }, { aDDVCD = '', beginTime = '' }) {
    return new Promise((resolve, reject) => {
      meiyuService.getRainlySeasonRainfall({ aDDVCD, beginTime }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取测站信息
   */
  [meiyuTypes.GET_PROJECT_GATES] ({ commit }) {
    return new Promise((resolve, reject) => {
      meiyuService.getProjectGates().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [meiyuTypes.GET_ANALYTICAL_RAIN] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      meiyuService.getAnalyticalRain(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }, /**
  * 报表生成
  */
  [meiyuTypes.SAVE_ONE_RAIN_WATER_NOTICE] (_, stationGroup) {
    return new Promise((resolve, reject) => {
      meiyuService.saveOneRainWaterNotice(stationGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
